<template>
  <div class="who_are_we">
    <div class="banner">
      <div class="banner_text">
        <h6>
          易招聘，让招聘更简单
        </h6>
        <p>极简易用的招聘管理工具，打通招聘平台，提高招聘效率</p>
      </div>
      <!-- <img class="dingding_banner" src="../../assets/img/who_are_we/banner.png" alt=""> -->
    </div>
    <div class="content2">
      <ul>
        <li>
          <span class="left">
            <h6>
              公司介绍
            </h6>
            <p>上海微星网络科技有限公司成立于2015年，注册资本5178万元，是国内领先的专注于轻量化SaaS应用的科技公司，致力于为中小微企业提供极简单、极易用、极流畅的企业级SaaS服务。</p>
            <p>
              易招聘是微星网络在人力招聘领域的自研品牌。其电脑端、微信小程序端、钉钉端、企业微信端数据互联互通，帮助企业实现高效的数字化招聘，盘点人才资产。易招聘拥有成熟的软件开发团队，满足大型企业定制需求。
            </p>
          </span>
          <div class="gap"></div>
          <span class="right">
            <img class="content_img" src="../../assets/img/who_are_we/content_1.png">
          </span>
        </li>
      </ul>
    </div>
    <div class="certificates">
      <h6>
        正规安全
      </h6>
      <ul class="imgs_1">
        <li><img src="../../assets/img/who_are_we/certificate_1.png"></li>
        <li><img src="../../assets/img/who_are_we/certificate_2.png"></li>
        <li><img src="../../assets/img/who_are_we/certificate_3.png"></li>
        <li><img src="../../assets/img/who_are_we/certificate_4.png"></li>
      </ul>
      <ul class="imgs_2">
        <li><img src="../../assets/img/who_are_we/certificate_5.png"></li>
        <li><img src="../../assets/img/who_are_we/certificate_6.png"></li>
        <li><img src="../../assets/img/who_are_we/certificate_7.png"></li>
        <li><img src="../../assets/img/who_are_we/certificate_8.png"></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    };
  },
  mounted: function () {
    this.$store.dispatch("first_nav_change", "7");
  },
  computed: {},
  methods: {

  }
};
</script>
<style lang="scss">
.who_are_we {
  .banner {
    background: url('../../assets/img/who_are_we/banner.png') center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .banner .banner_text {
    text-align: center;

    h6 {
      font-size: 40px;
      font-weight: 600;
      color: #ffffff;
    }

    p {
      font-size: 20px;
      color: #ffffff;
      font-weight: 400;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/whoAreWe.vue